import React from 'react'
import PropTypes from 'prop-types'

class TrainingCenterSelect extends React.Component {
  state = {
    trainingCenterId: this.props.trainingCenterId
  }

  onTrainingCenterChange = (e) => {
    this.setState({ trainingCenterId: e.target.value })
    setTimeout(function() { this.props.newTrainingCenterCallback(this.state.trainingCenterId) }.bind(this), 50)
  }

  render() {
    var options = this.props.trainingCenters.map(function(trainingCenter) {
      return (
        <option
          key={trainingCenter.id}
          value={trainingCenter.id}
        >
          {trainingCenter.name}
        </option>
      )
    })

    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Training Center'
                value={this.state.trainingCenterId}
                onChange={(e) => this.onTrainingCenterChange(e)}>
          <option value=''>
            All Training Centers
          </option>
          {options}
        </select>
      </div>
    )
  }
}

TrainingCenterSelect.propTypes = {
  trainingCenterid: PropTypes.number,
  trainingCenters: PropTypes.array,
  selectClassName: PropTypes.string
}

export default TrainingCenterSelect
